import ReactGA from "react-ga4";

const logEvent = (eventName: string, params: any) => {
    ReactGA.event(eventName, params);
};

export default logEvent;